import React from "react";

import { useNavigate } from "react-router-dom";
const tryagain =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/tryagain.svg";

export default function ClinicalTryAgain({
  isVisible,
  onClose,
  qid,
  treatment,
}) {
  const navigate = useNavigate();
  const handleTryAgain = () => {
    onClose();
    navigate("/clinical");
  };
  const handleHome = () => {
    onClose();
    navigate("/dashboard");
  };

  if (!isVisible) return null;
  return (
    <div
      className="popup-overlay startalign overflow-y-scroll pt-3 pb-3 items-start "
      onClick={onClose}
    >
      <div
        className="popup-content-congrats h-fit"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={tryagain} alt="Congrats" className="congratsimage" />
        <h1>Time Up</h1>
        <p className="textcenter">
          You have not scored minimum point to proceed to your next case. Please
          try again
        </p>
        <div className="flex flex-col">
          <div className="w-full flex flex-row items-center justify-between"></div>
          <div
            className="quickddxbody dashboardbodycontent"
            dangerouslySetInnerHTML={{ __html: treatment }}
          ></div>
        </div>
        <div className="contentcenter mt-4">
          <button className="elementselector" onClick={handleHome}>
            Home
          </button>
          <button className="elementselectorfilled" onClick={handleTryAgain}>
            Try Again
          </button>
          <button
            className="elementselectorfilled"
            onClick={() => navigate(`/qbank-question?id=${qid}&source=case`)}
          >
            Report
          </button>
        </div>
      </div>
    </div>
  );
}
